/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../../app/@shared/tracking/synthetic-performance-tracking.component';
import * as import2 from 'ngx-cookie/src/cookie.service';
const styles_SyntheticPerformanceTrackingComponent:any[] = ([] as any[]);
export const RenderType_SyntheticPerformanceTrackingComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_SyntheticPerformanceTrackingComponent,
  data: {}
}
);
export function View_SyntheticPerformanceTrackingComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
function View_SyntheticPerformanceTrackingComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'fl-synthetic-performance-tracking',([] as any[]),(null as any),(null as any),(null as any),View_SyntheticPerformanceTrackingComponent_0,RenderType_SyntheticPerformanceTrackingComponent)),
    import0.ɵdid(114688,(null as any),0,import1.SyntheticPerformanceTrackingComponent,[
      import2.CookieService,
      import0.Renderer2
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const SyntheticPerformanceTrackingComponentNgFactory:import0.ComponentFactory<import1.SyntheticPerformanceTrackingComponent> = import0.ɵccf('fl-synthetic-performance-tracking',import1.SyntheticPerformanceTrackingComponent,View_SyntheticPerformanceTrackingComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvc3ludGhldGljLXBlcmZvcm1hbmNlLXRyYWNraW5nLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3N5bnRoZXRpYy1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3N5bnRoZXRpYy1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMuU3ludGhldGljUGVyZm9ybWFuY2VUcmFja2luZ0NvbXBvbmVudC5odG1sIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy9zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmcuY29tcG9uZW50LnRzLlN5bnRoZXRpY1BlcmZvcm1hbmNlVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC1zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmc+PC9mbC1zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt5QkNBQTs7OztJQ0FBO2dCQUFBOzs7SUFBQTtLQUFBOzs7SUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/@shared/tracking/synthetic-performance-tracking.component.ngfactory.ts